;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.stepper = (function () {
    const initialize = function () {
      function findWithAttr (array, attr, value) {
        for (let i = 0; i < array.length; i += 1) {
          if (array[i][attr] === value) {
            return i
          }
        }
      }

      $('.js-stepper .stepper-button').on('click', function (e) {
        e.preventDefault()
        const $this = $(this)
        // Grab my owner.
        const $myStepper = $this.closest('.js-stepper')
        // Quickly read in the JSON array for this stepper.
        const myArray = $.parseJSON($myStepper.find('.json-hide').text())
        const myValue = $myStepper.find('input[type="hidden"]').val()
        // Determine the index of the current value of this stepper.
        let valueIndex = findWithAttr(myArray, 'value', myValue)

        if (typeof valueIndex === 'undefined') {
          console.log('Sorry, couldn\'t find the current value in the array.')
        } else {
          // console.log("The current array index is " + valueIndex);
        }

        // Act based on whether this listener is for the plus or the minus.
        if ($this.hasClass('minus')) {
          // console.log("We would decrement.");
          valueIndex = (valueIndex - 1 + myArray.length) % myArray.length
        } else if ($this.hasClass('plus')) {
          // console.log("We would increment.");
          valueIndex = (valueIndex + 1 + myArray.length) % myArray.length
        }

        $myStepper.find('.value').text(myArray[valueIndex].name)
        $myStepper.find('input[type="hidden"]').val(myArray[valueIndex].value)
      })

      // go ahead and click the correct items to handle any page load values that are set
      $('.js-stepper input[type="hidden"]').each(function (k, v) {
        const $this = $(this)
        const val = $this.attr('value')
        const $stepper = $this.closest('.js-stepper')
        const myArray = $.parseJSON($stepper.find('.json-hide').text())
        const valueIndex = findWithAttr(myArray, 'value', val)

        if ((typeof valueIndex !== 'undefined') && (valueIndex >= 0)) {
          $stepper.find('.value').text(myArray[valueIndex].name)
        } else {
          console.log('ERROR: Stepper ' + $this.attr('id') + 'couldn\'t find its starting value in array.')
        }
      })
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    eah.stepper.initialize()
  })
}(jQuery, window))
